import React from 'react';
import { Book, CheckCircle, Printer, MapPin } from 'lucide-react';
export function Volumes() {
  const volumes = [{
    num: 1,
    level: 'Jardín',
    title: 'El Despertar',
    desc: 'El primer contacto con el movimiento. Esquema corporal, lateralidad y confianza motriz.'
  }, {
    num: 2,
    level: 'Jardín',
    title: 'El Vuelo',
    desc: 'Coordinación dinámica, saltos y roles básicos con progresión clara semana a semana.'
  }, {
    num: 3,
    level: 'Jardín',
    title: 'La Consolidación',
    desc: 'Cierre del ciclo inicial. Evaluación, juego técnico y preparación para Escuela.'
  }, {
    num: 4,
    level: 'Escuela Femenina',
    title: 'Primeros Pasos',
    desc: 'Técnica de aparatos desde cero. Viga baja, suelo y cajón con progresión segura.'
  }, {
    num: 5,
    level: 'Escuela Femenina',
    title: 'Desarrollo',
    desc: 'Roles, verticales, rueda lateral y primeros elementos de aparatos con progresión completa.'
  }, {
    num: 6,
    level: 'Escuela Femenina',
    title: 'Competencia',
    desc: 'Secuencias de competencia nivel local. Criterios de evaluación y preparación al torneo.'
  }, {
    num: 7,
    level: 'Juvenil',
    title: 'Base Técnica',
    desc: 'Rondada, flic-flac asistido y kip. El salto cualitativo hacia la gimnasia avanzada.'
  }, {
    num: 8,
    level: 'Juvenil',
    title: 'Habilidades Intermedias',
    desc: 'Conexiones acrobáticas y series de aparatos con progresiones para grupos heterogéneos.'
  }, {
    num: 9,
    level: 'Juvenil',
    title: 'Proyección Competitiva',
    desc: 'Preparación para torneos regionales. Rutinas completas y criterios de selección.'
  }, {
    num: 10,
    level: 'Avanzada',
    title: 'Preparación Física',
    desc: 'Plan de fuerza y potencia para la temporada. Periodización completa sin equipamiento especial.'
  }, {
    num: 11,
    level: 'Avanzada',
    title: 'Alta Competencia',
    desc: 'Elementos de dificultad D, series completas y estrategia de puntaje máximo por aparato.'
  }, {
    num: 12,
    level: 'Avanzada',
    title: 'Temporada Oficial',
    desc: 'El manual de la temporada de competencias. Calentamiento, manejo de nervios y protocolo de rendimiento máximo el día del torneo.'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-289">
      <div className="max-w-6xl mx-auto px-4" data-id="element-290">
        <div className="text-center mb-16" data-id="element-291">
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4" data-id="element-292">
            Los 12 Tomos Completos
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-293">
            Progresiones técnicas · Por nivel y objetivo · Listo para usar
            mañana
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-294">
          {volumes.map(vol => <div key={vol.num} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200 hover:shadow-md transition-shadow group" data-id="element-295">
              <div className="flex items-center justify-between mb-4" data-id="element-296">
                <span className="text-sm font-bold text-blue-600 bg-blue-50 px-3 py-1 rounded-full" data-id="element-297">
                  TOMO {vol.num}
                </span>
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-298">
                  {vol.level}
                </span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors" data-id="element-299">
                "{vol.title}"
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-300">
                {vol.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm" data-id="element-301">
          <div className="grid md:grid-cols-4 gap-6" data-id="element-302">
            <div className="flex items-center gap-3" data-id="element-303">
              <Book className="w-6 h-6 text-blue-600" data-id="element-304" />
              <span className="font-medium text-gray-800" data-id="element-305">
                Progresiones técnicas en cada tomo
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-306">
              <CheckCircle className="w-6 h-6 text-emerald-600" data-id="element-307" />
              <span className="font-medium text-gray-800" data-id="element-308">
                Sistema "Abrí y Dictás"
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-309">
              <Printer className="w-6 h-6 text-purple-600" data-id="element-310" />
              <span className="font-medium text-gray-800" data-id="element-311">
                Planillas listas para imprimir
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-312">
              <MapPin className="w-6 h-6 text-red-500" data-id="element-313" />
              <span className="font-medium text-gray-800" data-id="element-314">
                Contenido 100% adaptado a Argentina
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}